export default __webpack_public_path__ + "static/fitness-weight-loss-8906ac52baf271e8be893b0d562b85ef.png";